module.exports = __webpack_public_path__ + "static/media/ue4.6a1971cd.png";